(() => {
    'use strict';

    real.events.on('transcribe:error', notification => {
        if(!notification.object?.uploadedfile?.id) {
            return;
        }

        const uploadedFileId = notification.object.uploadedfile.id;
        const transcriptContainer = $(`.transcript-container[data-uploadedfile-id="${uploadedFileId}"]`);
        if (transcriptContainer.length === 0) {
            return;
        }

        const transcriptProgressWrapper = transcriptContainer.find('.transcript-progress-wrapper');
        const transcriptContentWrapper = transcriptContainer.find('.transcript-content-wrapper');

        transcriptProgressWrapper.find('.transcribe-label').addClass('d-none');
        transcriptProgressWrapper.find('.transcript-progress').addClass('d-none');
        transcriptProgressWrapper.find('.transcript-error-alert').removeClass('d-none');

        transcriptContentWrapper.find('.transcript-view-content').removeClass('d-none');
        transcriptContentWrapper.find('.transcript-edit-content').addClass('d-none');

        transcriptContentWrapper.removeClass('d-none');
        // Nothing was replaced, so the summary of the current transcript still applies.
        transcriptContainer.find('.synopsis-wrapper').removeClass('d-none');
    });

})();
